import { Component,  OnInit } from '@angular/core';
import { DocumentService } from '../../../../../../UI/src/app/shared/document-upload/document-upload.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StsDialogService } from '../../../../../../UI/src/app/lib/dialog/dialog.service';
import { FileUploadDialogComponent } from '../file-upload/file-upload-dialog.component';
import { TranslateService } from '@ngx-translate/core'
import { NavController, NavParams, Events, ModalController } from 'ionic-angular';
import { DocumentImportComponent } from '../document-import/document-import.component';
import { ToastControllerService } from '../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../providers/toast-508.service';
import { AuthenticationService } from '../../../../../../UI/src/app/shared/authentication/authentication.service';
import { SigninComponent } from '../../../modules/authentication/components/signin/signin.component';
import { SubmitAlertDialogComponent } from '../submit-alert-dialog/submit-alert-dialog.component';
import { CandidateProfileComponent } from '../candidate-profile.component'

@Component({
  selector: 'sts-document-upload',
  templateUrl: 'document-upload.component.html',
})

export class DocumentUploadComponent implements OnInit {
  documentTypes: any;
  public translations: any;
  alertData: any;
  candidateDocumentTranslations: any;
  public showLoader = false;
  public isUploadSuccess = false;
  canEnableSubmit = false;
  isPageAccessible: boolean;
  isUnauthorizedUser: boolean;
  hidePage: boolean;
  public isLoggedIn = false;  
  public isFromPreviousPage = false;
  public documentId = '';
  public pageTitle = '';
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public documentService: DocumentService,
    private toastService: ToastControllerService,
    private toast508Service: Toast508Service,
    private authenticationService: AuthenticationService,   
    private translate: TranslateService,
    public  modalCtrl: ModalController,) {

      this.isLoggedIn = this.authenticationService.isUserLoggedin();
      this.documentId = navParams.data['Id'];
      this.events.publish('showSiteMapNodes', true);
      this.translate.get(['CAREERS_DOCUMENT_UPLOAD_SUCCESS_MESSAGE', 'CAREERS_DOCUMENT_UPLOAD_FAILED_MESSAGE',
      'CAREERS_DOCUMENT_SUBMIT_SUCCESS_MESSAGE','CAREERS_DOCUMENT_SUBMIT_FAILED_MESSAGE','CAREER_DOCUMENT_UPLOAD_REQUISITION_TITLE'])
      .subscribe((obj) => {
      this.candidateDocumentTranslations = obj;
      if (navParams.data && navParams.data['Id'] && this.isLoggedIn) {
        this.showLoader = true;
        this.getDocumnetsData(navParams.data['Id']);
      }
    });
  }

  ngOnInit() {    
    this.isUnauthorizedUser = false;
    this.isPageAccessible = true;
    this.hidePage = false;
    if(!this.isLoggedIn){    
      this.navCtrl.setRoot(SigninComponent, {'redirectedFrom' : 'documents', 'documentId': this.documentId });
    }  
  }

  ionViewWillEnter(){
    this.isUploadSuccess = this.navParams.get('isUploadSuccess');
    this.isFromPreviousPage = this.navParams.get('isFromPreviousPage');   
    if(this.isFromPreviousPage){
    this.showSuccessFailureMessage();    
    }
    this.enableSubmitButton();
  }

  showSuccessFailureMessage() {   
    if(this.isUploadSuccess){
    this.alertData = { message: this.candidateDocumentTranslations.CAREERS_DOCUMENT_UPLOAD_SUCCESS_MESSAGE, type: 'success' };
    }
    else if (this.isUploadSuccess) {
    this.alertData = { message: this.candidateDocumentTranslations.CAREERS_DOCUMENT_UPLOAD_FAILED_MESSAGE, type: 'error' };
    }    
    this.toastService.presentToast(this.alertData);
    this.toast508Service.toFocus();
  }

  getDocumnetsData(applicationPhaseId) {
    //fetching all the document types for the respective phase id.
    this.documentService.fetchDocumentTypes(applicationPhaseId)
      .subscribe((response) => {        
        this.documentTypes = response;
        this.pageTitle = this.documentTypes[0].requisitionTitle;
        this.documentService.documentTypes = this.documentTypes;
        this.enableSubmitButton();
        this.showLoader = false;
      }, (error) => {
        this.showLoader = false;
        if (error.status === 412) {
          this.isPageAccessible = false;
        } else if (error.status === 401) {
          this.isUnauthorizedUser = true;
        } else {
          this.hidePage = true;
          this.alertData = { message: this.candidateDocumentTranslations.CAREER_DOCUMENT_GET_FAILURE_MESSAGE, type: 'error' };
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
        }
    });
  }

  enableSubmitButton() {
    this.canEnableSubmit = true;
    this.documentTypes.forEach(element => {
      if (element.fileAssetId === 0) {
        this.canEnableSubmit = false;
      }
    });
  }

  public submit(documentTypes) {    

    let submitDocumentModalRef = this.modalCtrl.create(SubmitAlertDialogComponent, { data: documentTypes  });
    submitDocumentModalRef.present();
    submitDocumentModalRef.onDidDismiss((result) => {      
      if (result) {
        this.canEnableSubmit = false;
        if(result)
        {
          this.alertData = { message: this.candidateDocumentTranslations.CAREERS_DOCUMENT_SUBMIT_SUCCESS_MESSAGE, type: 'success' };
        }
        else
        {
          this.alertData = { message: this.candidateDocumentTranslations.CAREERS_DOCUMENT_SUBMIT_FAILED_MESSAGE, type: 'error' };
        }        
        this.navCtrl.pop();         
        this.navCtrl.setRoot(CandidateProfileComponent);     
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();
      }
      submitDocumentModalRef.dismiss();
    });
  }

  public uploadFile(documentType, index) {
    this.navCtrl.push(DocumentImportComponent, {
      documentType: documentType,
      index: index
    });
  }

  public saveForLater(documentTypes) {
    this.showLoader = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/candidate-profile/document-upload/document-upload.component.ts